/**
 * Dev-only model picker helpers.
 *
 * Models are sent to Mastra in the format `openrouter/<author>/<model>`
 * (e.g. `openrouter/deepseek/deepseek-v4-flash`).
 */

/** Curated "top" models, pinned above the full OpenRouter catalog. Ordered by OpenRouter weekly ranking. */
export const DEBUG_MODELS: readonly string[] = [
  'openrouter/deepseek/deepseek-v4-flash',
  'openrouter/tencent/hy3-preview',
  'openrouter/anthropic/claude-opus-4.7',
  'openrouter/anthropic/claude-sonnet-4.6',
  'openrouter/nvidia/nemotron-3-super',
  'openrouter/xiaomi/mimo-v2.5',
  'openrouter/minimax/minimax-m3',
  'openrouter/deepseek/deepseek-v4-pro',
  'openrouter/xiaomi/mimo-v2.5-pro',
  'openrouter/deepseek/deepseek-v3.2',
  'openrouter/stepfun/step-3.7-flash',
  'openrouter/qwen/qwen3.7-plus',
  'openrouter/z-ai/glm-5.2',
  'openrouter/anthropic/claude-haiku-4.5',
  'openrouter/anthropic/claude-opus-4.8',
] as const;

/**
 * Normalize an OpenRouter model id (e.g. `deepseek/deepseek-v4-flash` or
 * `~google/gemini-pro-latest`) into the Mastra value `openrouter/<id>`.
 *
 * Every model sent to the backend MUST carry the `openrouter/` prefix. This is
 * idempotent: any pre-existing `openrouter/` prefix is collapsed and re-added
 * exactly once, so the result always starts with a single `openrouter/`.
 */
export const toMastraModel = (openRouterId: string): string => {
  const clean = openRouterId.replace(/^~/, '').replace(/^\/+/, '').trim();
  if (!clean) return '';
  const withoutPrefix = clean.replace(/^(?:openrouter\/)+/, '');
  return `openrouter/${withoutPrefix}`;
};

/**
 * Provider key used to fetch a logo from models.dev — the author segment of the
 * Mastra value. `openrouter/deepseek/deepseek-v4-flash` -> `deepseek`.
 * Returns `undefined` when no author segment is present.
 */
export const getModelProvider = (mastraValue: string): string | undefined => mastraValue.split('/')[1] || undefined;
